module.exports = __webpack_public_path__ + "img/incidence-travel-check.452aeb70.svg";